"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.regions = exports.states = exports.statesByAbbrev = exports.territoriesByAbbrev = exports.territories = void 0;
const AL = { name: 'Alabama', value: 'AL', region: 'S', tokens: ['Alabama'] };
const AK = { name: 'Alaska', value: 'AK', region: 'W', tokens: ['Alaska'] };
const AZ = { name: 'Arizona', value: 'AZ', region: 'W', tokens: ['Arizona'] };
const AR = { name: 'Arkansas', value: 'AR', region: 'S', tokens: ['Arkansas'] };
const CA = { name: 'California', value: 'CA', region: 'W', tokens: ['California'] };
const CO = { name: 'Colorado', value: 'CO', region: 'W', tokens: ['Colorado'] };
const CT = { name: 'Connecticut', value: 'CT', region: 'NE', tokens: ['Connecticut'] };
const DE = { name: 'Delaware', value: 'DE', region: 'S', tokens: ['Delaware'] };
const DC = { name: 'District of Columbia', value: 'DC', region: 'S', tokens: ['District of Columbia'] };
const FL = { name: 'Florida', value: 'FL', region: 'S', tokens: ['Florida'] };
const GA = { name: 'Georgia', value: 'GA', region: 'S', tokens: ['Georgia'] };
const HI = { name: 'Hawaii', value: 'HI', region: 'W', tokens: ['Hawaii'] };
const ID = { name: 'Idaho', value: 'ID', region: 'W', tokens: ['Idaho'] };
const IL = { name: 'Illinois', value: 'IL', region: 'MW', tokens: ['Illinois'] };
const IN = { name: 'Indiana', value: 'IN', region: 'MW', tokens: ['Indiana'] };
const IA = { name: 'Iowa', value: 'IA', region: 'MW', tokens: ['Iowa'] };
const KS = { name: 'Kansas', value: 'KS', region: 'MW', tokens: ['Kansas'] };
const KY = { name: 'Kentucky', value: 'KY', region: 'S', tokens: ['Kentucky'] };
const LA = { name: 'Louisiana', value: 'LA', region: 'S', tokens: ['Louisiana'] };
const ME = { name: 'Maine', value: 'ME', region: 'NE', tokens: ['Maine'] };
const MD = { name: 'Maryland', value: 'MD', region: 'S', tokens: ['Maryland'] };
const MA = { name: 'Massachusetts', value: 'MA', region: 'NE', tokens: ['Massachusetts'] };
const MI = { name: 'Michigan', value: 'MI', region: 'MW', tokens: ['Michigan'] };
const MN = { name: 'Minnesota', value: 'MN', region: 'MW', tokens: ['Minnesota'] };
const MS = { name: 'Mississippi', value: 'MS', region: 'S', tokens: ['Mississippi'] };
const MO = { name: 'Missouri', value: 'MO', region: 'MW', tokens: ['Missouri'] };
const MT = { name: 'Montana', value: 'MT', region: 'W', tokens: ['Montana'] };
const NE = { name: 'Nebraska', value: 'NE', region: 'MW', tokens: ['Nebraska'] };
const NV = { name: 'Nevada', value: 'NV', region: 'W', tokens: ['Nevada'] };
const NH = { name: 'New Hampshire', value: 'NH', region: 'NE', tokens: ['New Hampshire'] };
const NJ = { name: 'New Jersey', value: 'NJ', region: 'NE', tokens: ['New Jersey'] };
const NM = { name: 'New Mexico', value: 'NM', region: 'W', tokens: ['New Mexico'] };
const NY = { name: 'New York', value: 'NY', region: 'NE', tokens: ['New York'] };
const NC = { name: 'North Carolina', value: 'NC', region: 'S', tokens: ['North Carolina'] };
const ND = { name: 'North Dakota', value: 'ND', region: 'MW', tokens: ['North Dakota'] };
const OH = { name: 'Ohio', value: 'OH', region: 'MW', tokens: ['Ohio'] };
const OK = { name: 'Oklahoma', value: 'OK', region: 'S', tokens: ['Oklahoma'] };
const OR = { name: 'Oregon', value: 'OR', region: 'W', tokens: ['Oregon'] };
const PA = { name: 'Pennsylvania', value: 'PA', region: 'NE', tokens: ['Pennsylvania'] };
const RI = { name: 'Rhode Island', value: 'RI', region: 'NE', tokens: ['Rhode Island'] };
const SC = { name: 'South Carolina', value: 'SC', region: 'S', tokens: ['South Carolina'] };
const SD = { name: 'South Dakota', value: 'SD', region: 'MW', tokens: ['South Dakota'] };
const TN = { name: 'Tennessee', value: 'TN', region: 'S', tokens: ['Tennessee'] };
const TX = { name: 'Texas', value: 'TX', region: 'S', tokens: ['Texas'] };
const UT = { name: 'Utah', value: 'UT', region: 'W', tokens: ['Utah'] };
const VT = { name: 'Vermont', value: 'VT', region: 'NE', tokens: ['Vermont'] };
const VA = { name: 'Virginia', value: 'VA', region: 'S', tokens: ['Virginia'] };
const WA = { name: 'Washington', value: 'WA', region: 'W', tokens: ['Washington'] };
const WV = { name: 'West Virginia', value: 'WV', region: 'S', tokens: ['West Virginia'] };
const WI = { name: 'Wisconsin', value: 'WI', region: 'MW', tokens: ['Wisconsin'] };
const WY = { name: 'Wyoming', value: 'WY', region: 'W', tokens: ['Wyoming'] };
//territories
const AS = { name: 'American Samoa', value: 'AS', region: 'INT', tokens: ['American Samoa'] };
const FM = { name: 'Micronesia', value: 'FM', region: 'INT', tokens: ['Micronesia'] };
const GU = { name: 'Guam', value: 'GU', region: 'INT', tokens: ['Guam'] };
const MH = { name: 'Marshall Islands', value: 'MH', region: 'INT', tokens: ['Marshall Islands'] };
const MP = {
    name: 'Northern Marianas Islands',
    value: 'MP',
    region: 'INT',
    tokens: ['Northern Marianas Islands'],
};
const PR = { name: 'Puerto Rico', value: 'PR', region: 'INT', tokens: ['Puerto Rico'] };
const PW = { name: 'Palau', value: 'PW', region: 'INT', tokens: ['Palau'] };
const VI = { name: 'U.S. Virgin Islands', value: 'VI', region: 'INT', tokens: ['U.S. Virgin Islands'] };
const AA = {
    name: 'Army Post Office, Armed Forces Americas',
    value: 'AA',
    region: 'INT',
    tokens: ['Army Post Office, Armed Forces Americas'],
};
const AE = {
    name: 'Army Post Office, Armed Forces Europe',
    value: 'AE',
    region: 'INT',
    tokens: ['Army Post Office, Armed Forces Europe'],
};
const AP = {
    name: 'Army Post Office, Armed Forces Pacific',
    value: 'AP',
    region: 'INT',
    tokens: ['Army Post Office, Armed Forces Pacific'],
};
exports.territories = [AS, FM, GU, MH, MP, PR, PW, VI, AA, AE, AP];
exports.territoriesByAbbrev = {
    AS,
    FM,
    GU,
    MH,
    MP,
    PR,
    PW,
    VI,
    AA,
    AE,
    AP,
};
exports.statesByAbbrev = {
    AL,
    AK,
    AZ,
    AR,
    CA,
    CO,
    CT,
    DE,
    DC,
    FL,
    GA,
    HI,
    ID,
    IL,
    IN,
    IA,
    KS,
    KY,
    LA,
    ME,
    MD,
    MA,
    MI,
    MN,
    MS,
    MO,
    MT,
    NE,
    NV,
    NH,
    NJ,
    NM,
    NY,
    NC,
    ND,
    OH,
    OK,
    OR,
    PA,
    RI,
    SC,
    SD,
    TN,
    TX,
    UT,
    VT,
    VA,
    WA,
    WV,
    WI,
    WY,
};
exports.states = [
    AL,
    AK,
    AZ,
    AR,
    CA,
    CO,
    CT,
    DE,
    DC,
    FL,
    GA,
    HI,
    ID,
    IL,
    IN,
    IA,
    KS,
    KY,
    LA,
    ME,
    MD,
    MA,
    MI,
    MN,
    MS,
    MO,
    MT,
    NE,
    NV,
    NH,
    NJ,
    NM,
    NY,
    NC,
    ND,
    OH,
    OK,
    OR,
    PA,
    RI,
    SC,
    SD,
    TN,
    TX,
    UT,
    VT,
    VA,
    WA,
    WV,
    WI,
    WY,
];
exports.regions = [
    {
        international: false,
        name: 'Northeast',
        abbrev: 'NE',
        states: [CT, ME, MA, NH, NJ, NY, PA, RI, VT],
    },
    {
        international: false,
        name: 'South',
        abbrev: 'S',
        states: [AL, AR, DE, FL, GA, NC, KY, LA, MD, MS, OK, SC, TN, TX, VA, DC, WV],
    },
    {
        international: false,
        name: 'Midwest',
        abbrev: 'MW',
        states: [IL, IN, IA, KS, MI, MN, MO, NE, ND, OH, SD, WI],
    },
    {
        international: false,
        name: 'West',
        abbrev: 'W',
        states: [AK, AZ, CA, CO, HI, ID, MT, NV, NM, OR, UT, WA, WY],
    },
    {
        international: true,
        name: 'International & Territories',
        abbrev: 'INT',
        territories: [AS, FM, GU, MH, MP, PR, PW, VI, AA, AE, AP],
    },
];
